import Nullstack from 'nullstack';
export default function IconChartDots3({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-dots-3",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "7",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "6",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "18",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M9 17l5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 8.5l7.81 5.37"
  }), "   ", Nullstack.element("path", {
    d: "M7 7l8 -1"
  }), " ");
}